import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { blue, green } from '@mui/material/colors';
import { Box, capitalize, Theme, Typography } from '@mui/material';

interface Props {
  condition: string;
}

export const ConditionBadge = ({ condition }: Props) => {
  const mappedCondition = condition?.toLowerCase() ?? '';

  const classes = useStyles({ condition: mappedCondition });

  return (
    <Box
      className={clsx({
        [classes.new]: mappedCondition === 'new',
        [classes.used]: mappedCondition === 'used',
      })}
      sx={{ padding: '0 0.4rem', borderRadius: '0.25rem', width: 'fit-content' }}
    >
      <Typography variant="body1">{capitalize(mappedCondition)}</Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme>(({ shadows }) => ({
  new: {
    color: blue[900],
    backgroundColor: blue[200],
    border: `1px solid ${blue[500]}`,
  },
  used: {
    color: green[900],
    backgroundColor: green[200],
    border: `1px solid ${green[500]}`,
  },
}));
